import { render, staticRenderFns } from "./ProjectGallery.vue?vue&type=template&id=97189e40&scoped=true&"
import script from "./ProjectGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGallery.vue?vue&type=style&index=0&id=97189e40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97189e40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VFadeTransition,VIcon,VImg,VProgressCircular,VRow,VSpacer})
